// extracted by mini-css-extract-plugin
export default {"sideMenu":"bc-side-menu_sideMenu__NmN9g","separator":"bc-side-menu_separator__AAjnn","menuToggleBtn":"bc-side-menu_menuToggleBtn__MaHoi"};